import { render, staticRenderFns } from "./ServeContractList.vue?vue&type=template&id=a559fad0"
import script from "./ServeContractList.vue?vue&type=script&lang=js"
export * from "./ServeContractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports